import { useFieldArray, useForm, useWatch } from "react-hook-form";
import {
  DatePicker,
  Input,
  Label,
  MultipleSelect,
  Select,
  Submit,
  TextArea,
} from "../FormComponents";
import useLabels from "../../hooks/useLabels";
import { useNavigate, useParams } from "react-router";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useDispatch, useSelector } from "react-redux";
import {
  getOperations,
  getWineLabels,
  newOperation,
  updateOperation,
} from "../../services/utils";
import {
  ConfirmationModal,
  CTA,
  DestinationSelector,
  OperationRecap,
  SourceSelector,
} from "../Generic";
import {
  ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
  INT_REGEX,
} from "../../constants/regex";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  selectAllLotNames,
  selectOperations,
  selectVirtualTanks,
  selectWineLabels,
} from "../../context/selectors";
import { setWineLabels } from "../../context/wineLabels/wineLabelsSlice";
import { DestLotDetail, DestTankDetail } from "../OperationsDetail/Details";
import {
  add,
  empty,
  setOperations,
  updateOp,
} from "../../context/operations/operationsSlice";
import { emptyTanks } from "../../context/tanks/tanksSlice";
import { emptyLots } from "../../context/lots/lotsSlice";

const DestemmingForm = ({
  type,
  operation,
  lots,
  activeWinery,
  tanks,
  users,
  configs,
  isMobile,
  isDuplicate = false,
}) => {
  const { id } = useParams();
  const [getLabel] = useLabels();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const dispatch = useDispatch();
  const wineLabels = useSelector(selectWineLabels);
  const [isOpen, setIsOpen] = useState(false);
  const [isExactDate, setIsExactDate] = useState(false);
  // const [newBatchNames, setNewBatchNames] = useState(new Set());
  const operations = useSelector(selectOperations);
  const lotNames = useSelector(selectAllLotNames);
  // const virtualTanks = useSelector(selectVirtualTanks);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setError,
    clearErrors,
    reset,
    setValue,
    getValues,
    resetField,
    control,
    trigger,
  } = useForm({
    defaultValues: {
      src_tanks: operations?.src_tanks,
      dest_tanks: operation?.dest_tanks || [
        {
          tankData: { value: null, label: null },
          quantity: 0,
          new_batch_name: "",
          batch_name_selector: false,
        },
      ],
      // batchType: operation?.batchType || "",
      expire_date: operation?.expire_date || null,
      type: "DESTEMMING",
      batch_id_in: operation?.batch_id_in || "",
      priority: operation?.priority || "",
      cellarman_ids: operation?.cellarman_ids || "",
      new_batch_name: operation?.new_batch_name || "",
    },
    mode: "onTouched",
  });

  const { batch_id_in, dest_tanks } = useWatch({ control });

  const {
    fields,
    append,
    prepend,
    remove,
    swap,
    move,
    insert,
    replace,
    update,
  } = useFieldArray({
    control,
    name: "dest_tanks",
  });

  const loadOperations = async () => {
    const loadedOperations = await getOperations(axiosPrivate);
    dispatch(setOperations(loadedOperations));
  };

  const loadWineLabels = async () => {
    const currentWineLabels = await getWineLabels(axiosPrivate);
    dispatch(setWineLabels(currentWineLabels));
  };

  useEffect(() => {
    if (!wineLabels || wineLabels.length === 0) {
      loadWineLabels();
    }

    if (id && (!operations || operations?.length === 0)) loadOperations();
    if (id && operations?.length > 0) {
      const operation = operations?.find((o) => o.id === Number(id)) || null;
      if (operation === null) return;

      const lot = lots?.find((l) => l.id === operation?.batch_id_in);
      setValue("batch_id_in", {
        value: lot?.id,
        label: lot?.name,
        color: lot?.color,
        initial_quantity: lot?.quantity,
        quantity: lot?.actual_quantity,
        planned_quantity: lot?.planned_quantity,
        shared_operation_ids: lot?.shared_operation_ids,
        composition: lot?.composition,
        is_planned: lot?.is_planned,
        arrow_quantity: getTotalQuantity(true),
      });

      // const chosenQuantity = operation?.dest_tanks?.reduce((acc, curr) => {
      //   return acc + (Number(curr?.quantity) || 0);
      // }, 0);
      // setValue("batch_id_in_quantity", chosenQuantity);

      setValue("priority", {
        label: getLabel(`operationPriority${operation?.priority}`),
        value: operation?.priority,
      });

      // setValue("batchType", {
      //   label: getLabel(`lotType${operation?.batch_type}`),
      //   value: operation?.batch_type,
      // });

      setDestTanks();

      // setNewBatchNames(computeLotNames());

      const cellarmans = [];
      operation?.cellarman_ids?.map((u) => {
        const user = users?.find((us) => us.id === u);
        cellarmans.push({
          value: u,
          label: user?.username,
        });
      });
      setValue("cellarman_ids", cellarmans);

      setValue("expire_date", operation?.expire_date);

      setValue("note", operation?.note);
    }
    if (!id) {
      const savedInputLot = localStorage.getItem("selectedInputLotOperation");
      if (savedInputLot) {
        const { type, id } = JSON.parse(savedInputLot);
        const lot = lots?.find((l) => l?.id === Number(id));

        if (type === "lot" && id && lot) {
          setValue("batch_id_in", {
            value: lot?.id,
            label: lot?.name,
            color: lot?.color,
            initial_quantity: lot?.quantity,
            quantity: lot?.actual_quantity,
            planned_quantity: lot?.planned_quantity,
            shared_operation_ids: lot?.shared_operation_ids,
            composition: lot?.composition,
            is_planned: lot?.is_planned,
            arrow_quantity: getTotalQuantity(true),
          });

          localStorage.removeItem("selectedInputLotOperation");
        }
      }
    }
  }, [operations, operation, lots]);

  const computeLotNames = (idx = null, isValidate = false) => {
    const names = new Set();
    if (getValues("batch_id_in")?.label)
      names.add(getValues("batch_id_in")?.label);

    // lots?.filter((l) => l?.state === 'MUST' && (new Date(l?.insertion_date) >= addMonths(new Date(), -6)))?.reduce((_, l) => names.add(l?.name), null);
    lotNames
      ?.filter((l) => l?.state === "MUST")
      ?.reduce((_, l) => names.add(l?.name), null);

    if (dest_tanks?.length === 1 && dest_tanks?.[0]?.tankData?.value === null)
      return names;

    dest_tanks
      ?.filter((tank) => tank?.tankData?.quantity > 0)
      ?.reduce((_, item) => names.add(item?.tankData?.lot), null);

    if (!isValidate) {
      for (const tank of dest_tanks) {
        if (tank?.new_batch_name?.length > 0) names.add(tank?.new_batch_name);
      }
      let i = 0;
      for (const tank of dest_tanks?.filter(
        (t) => t?.tankData?.value && "batch_name_selector" in t
      )) {
        if (
          tank?.batch_name_selector?.value === false &&
          !Array.from(names.values())?.includes(
            tank?.batch_name_selector?.label
          )
        ) {
          setValue(`dest_tanks.${i}.batch_name_selector`, {
            value: "",
            label: "",
          });
        }
        i += 1;
      }
    }

    const nameObjects = [];
    names?.forEach((s) => {
      if (s) nameObjects.push({ value: false, label: s });
    });

    const new_batch_name = dest_tanks?.[idx]?.new_batch_name || "";

    const batch_name_label = dest_tanks?.[idx]?.batch_name_selector?.label;
    const batch_name_value = dest_tanks?.[idx]?.batch_name_selector?.value;
    const new_name = (
      batch_name_value ? new_batch_name : batch_name_label
    )?.trim(); // remove the already set batch_name from the list

    return nameObjects
      ?.filter((n) => n?.label !== new_name)
      ?.sort((a, b) =>
        a?.label > b?.label ? 1 : b?.label > a?.label ? -1 : 0
      );
  };

  const customIdMissingDests = "custom-id-missing-dests";
  const sendData = async () => {
    if (Object.keys(errors)?.length > 0) return;
    const data = getValues();
    // if (!data?.batch_name_selector?.value) {
    //   data.new_batch_name = data?.batch_name_selector?.label;
    // }
    // return;

    const dests = [];
    const newBatchIds = [];
    const sorted_dest_tanks = dest_tanks
      ?.sort(function (a, b) {
        return b?.batch_name_selector?.value - a?.batch_name_selector?.value;
      })
      ?.filter(
        (d) => d?.tankData?.value && d?.quantity
        // &&
        // ((d?.batch_name_selector === false &&
        //   d?.new_batch_name === "" &&
        //   d?.tankData?.is_planned &&
        //   Number(d?.tankData?.planned_quantity) > 0) || // when extending a planned batch
        //   (d?.batch_name_selector?.value === true && d?.new_batch_name) ||
        //   (d?.batch_name_selector?.value === false &&
        //     d?.batch_name_selector?.label))
      );

    for (const destT of sorted_dest_tanks) {
      const tankData = destT?.tankData;

      // const isPlanned =
      //   tankData?.value &&
      //   tankData?.is_planned_by_other_ops &&
      //   Number(tankData?.quantity) === 0 &&
      //   // Number(tankData?.planned_quantity) === 0 &&
      //   tankData?.is_planned;

      const isPlanned = tankData?.is_planned;

      // const new_batch_name2 = isPlanned
      //   ? tankData?.planned_batch_name
      //   : destT?.new_batch_name;

      const batch_name_label = destT?.batch_name_selector?.label;
      const batch_name_value = destT?.batch_name_selector?.value;
      const new_batch_name = batch_name_value
        ? destT?.new_batch_name
        : batch_name_label || tankData?.planned_batch_name;

      const isPlannedByOtherOps =
        tankData?.is_planned &&
        ((id === null && tankData?.programmed_as_dest?.length > 0) ||
          (id !== null &&
            tankData?.programmed_as_dest?.some((p_id) => p_id !== Number(id))));

      const new_name = (
        isPlanned && isPlannedByOtherOps
          ? tankData?.planned_batch_name
          : batch_name_value
          ? new_batch_name
          : batch_name_label
      )?.trim();

      // console.log('destT', destT, 'tankData', tankData, 'isPlanned', isPlanned, 'isPlannedByOtherOps', isPlannedByOtherOps, 'new_name', new_name);

      const plannedLot =
        lots?.find((l) => l?.name === new_name && l?.status === "PLANNED") ||
        null;
      // const isPlannedByOtherOps = plannedLot
      //   ? plannedLot?.shared_operation_ids?.some(
      //       (opId) => Number(opId) !== Number(id)
      //     )
      //   : false;
      // const isPlannedByOtherOps =
      //   tankData?.is_planned && plannedLot?.shared_operation_ids?.length > 0
      //     ? id
      //       ? plannedLot.shared_operation_ids.some((opId) => Number(opId) !== Number(id))
      //       : true
      //     : false;

      // TO DO isPlannedByOtherOps in CutForm is like isPlannedByOtherOps2 (non funziona se id === null ma uso un lotto giá programmato)

      const isPlannedByOtherOps2 =
        id && tankData?.is_planned
          ? plannedLot?.shared_operation_ids?.some(
              (opId) => Number(opId) !== Number(id)
            ) || false
          : tankData?.is_planned && tankData?.planned_batch_name
          ? true
          : false;

      // if (tankData?.value === 89) console.log(' id && tankData?.is_planned', (tankData?.is_planned && tankData?.planned_batch_name) ? true : false)

      const destLot =
        lots?.find((l) => l?.name === new_name && l.state === "MUST") || null;
      const type = destLot?.id && !isPlannedByOtherOps ? "OLD" : "NEW";

      if (type === null) {
        toast.error(getLabel("toast_invalidType"), {
          toastId: customIdInvalidLotName,
          position: toast.POSITION.BOTTOM_RIGHT,
          exclude: true,
          autoClose: 5000,
        });
        return;
      }
      // const newName = tankData?.is_planned ? tankData?.planned_batch_name :
      //   destT?.batch_name_selector?.value === true
      //     ? destT?.new_batch_name
      //     : destT?.batch_name_selector?.label;

      // if (type === "NEW" && !newBatchIds?.includes(newName)) {
      // newBatchIds.push(newName);
      // TO DO check all cases
      // }

      if (String(new_name)?.length === 0) {
        console.error("Invalid new_name");
        return;
      }

      const t = tanks?.find((t) => t.id === tankData?.value) || {};
      const dest = {
        tank_id: tankData?.value,
        quantity: Number(destT.quantity),
        is_new:
          destT?.batch_name_selector?.value === true &&
          destT?.new_batch_name?.length > 0 &&
          lots?.find((l) => l?.name === new_name && l?.state === "MUST")?.id ===
            undefined,
        new_batch_name: new_name,
        new_batch_id: destLot?.id || null,
        // new_batch_type: type,
        old_batch_id: t?.batch_id || "",
        old_quantity: t?.quantity || 0,
        new_quantity:
          (Number(t?.quantity || 0) || 0) + (Number(destT.quantity) || 0),
      };
      dests.push(dest);
    }
    // console.log("dests", dests);
    // return;

    if (dests?.length === 0) {
      toast.error(getLabel("toast_missingDestTanks"), {
        toastId: customIdInvalidLotName,
        position: toast.POSITION.BOTTOM_RIGHT,
        exclude: true,
        autoClose: 5000,
      });
      return;
    }
    const tmpDate = new Date(data?.expire_date)?.setHours(23, 59, 59);

    const requestPayload = {
      ...(id && { id: id }),
      src_tanks: [
        {
          color: data?.batch_id_in?.color,
          old_quantity: data?.batch_id_in?.quantity,
          name: data?.batch_id_in?.label,
          batch_id: data?.batch_id_in?.value,
        },
      ],
      dest_tanks: dests,
      priority: data?.priority.value,
      // batch_type: data?.batchType?.value,
      // expire_date: addMinutes(
      //   new Date(data?.expire_date)?.setHours(23, 59, 59),
      //   -new Date(data?.expire_date).getTimezoneOffset()
      // ).toISOString(),
      is_exact_date: isExactDate,
      expire_date: new Date(tmpDate)?.toISOString(),
      type: data?.type,
      winery_id: activeWinery?.id,
      cellarman_ids: data?.cellarman_ids?.map((cellMan) => cellMan?.value),
      // new_batch_name: data?.new_batch_name,
      batch_id_in: data?.batch_id_in?.value,
      note: data?.note,
    };
    console.log("requestPayload", requestPayload?.dest_tanks);
    // return;
    const toastId = toast.loading(getLabel("toast_inProgress"), {
      type: toast.TYPE.INFO,
      position: toast.POSITION.BOTTOM_RIGHT,
      exclude: true,
    });
    let response = null;

    if (id && !isDuplicate) {
      response = await updateOperation(id, requestPayload, axiosPrivate);
    } else {
      response = await newOperation(requestPayload, axiosPrivate);
    }
    console.log(response);
    toast.update(toastId, {
      render: response?.success
        ? getLabel(response?.success, { type: operation?.type || "" })
        : getLabel(response?.error),
      type:
        !response || response?.error ? toast.TYPE.ERROR : toast.TYPE.SUCCESS,
      isLoading: false,
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 4000,
    });

    if (response && response?.success) {
      const updated_op = response?.updated_data || null;
      // dispatch(empty());
      updateStore(updated_op);
      navClickHandler();
    }
  };

  const updateStore = (payloadOp) => {
    // const tankIds = [...payload?.src_tanks, ...payload?.dest_tanks]?.map(t => t?.tank_id || null)?.filter(Boolean); // remove nulls
    if (id && !isDuplicate) {
      dispatch(updateOp(payloadOp));
    } else {
      dispatch(add(payloadOp));
    }
    dispatch(emptyLots());
    dispatch(emptyTanks());

    // if (payload.id) {
    //   dispatch(emptyLots());
    // } else {
    //   dispatch(add(payload));
    // }
  };

  const navClickHandler = () => {
    if (id) {
      navigate(`/programming/DESTEMMING/${id}`);
    } else {
      navigate("/programming");
    }
  };

  const getError = (idx, data, key) => {
    if (
      !errors ||
      Object.keys(errors)?.length === 0 ||
      !data ||
      data?.length <= idx
    )
      return;

    return data?.[idx]?.[key] || null;
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const getTotalQuantity = (isOperation = false) => {
    const batch_id_in = getValues("batch_id_in") || {};
    if (
      !id &&
      !isOperation &&
      batch_id_in?.is_planned &&
      Number(batch_id_in?.planned_quantity) <= 0
    )
      return 0; // i.e. if the in batch is all planned in other dests

    return (
      (isOperation ? operation?.dest_tanks : dest_tanks)?.reduce(
        (acc, curr) => {
          return acc + (Number(curr?.quantity) || 0);
        },
        0
      ) || 0
    );
  };

  const getWineLabelsOptions = () => {
    if (!wineLabels || wineLabels?.length === 0) return [];
    if (
      getValues("label") &&
      getValues("label")?.filter((l) => l?.type !== "label")?.length > 0
    )
      return wineLabels?.labels;
    return [...wineLabels?.wine, ...wineLabels?.labels] || [];
  };

  const customIdInvalidColor = "custom-id-invalid-color";
  const customIdInvalidLotName = "custom-id-invalid-lot-name";
  const customIdInvalidQuantities = "custom-id-invalid-quantities";
  const openFormModal = () => {
    // console.log('errors', errors)
    // trigger();

    const expDate = getValues("expire_date");
    const tmpDate = new Date(expDate)?.setHours(23, 59, 59);
    if (!expDate || !tmpDate || new Date(tmpDate) < new Date()) {
      setError("expire_date", {
        type: "manual",
        message: getLabel("errorDateInThePast"),
      });
      return;
    }

    if (dest_tanks?.filter((t) => t?.tankData?.value)?.length === 0) {
      toast(getLabel("toast_destemmingMissingDests"), {
        toastId: customIdMissingDests,
        type: toast.TYPE.ERROR,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    } else {
      toast.dismiss(customIdMissingDests);
    }

    if (
      dest_tanks?.filter(
        (t) =>
          (!t?.batch_name_selector?.value &&
            t?.batch_name_selector?.label?.length === 0) ||
          (t?.batch_name_selector?.value === true &&
            t?.new_batch_name?.length === 0)
      )?.length > 0
    ) {
      toast(getLabel("toast_destemmingMissingLotSelectors"), {
        toastId: customIdMissingDests,
        type: toast.TYPE.ERROR,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    } else {
      toast.dismiss(customIdMissingDests);
    }

    // const filteredTanks = dest_tanks?.filter((d) => d?.tankData?.value);
    // if (filteredTanks?.length === 1)
    //   setValue(
    //     "dest_tanks.0.quantity",
    //     getTotalQuantity()
    //   );

    const destemmingLiters = getTotalQuantity();
    // return;
    const allocated = getTotalQuantity();
    const allocatedInitialQuantity = id ? getTotalQuantity(id > 0) : 0;

    const lot = getValues("batch_id_in");
    const availableForCurrentOp =
      allocatedInitialQuantity + (Number(lot?.planned_quantity) || 0);

    // The current operation can only remove as much as is available
    const totalKgAvailable = Math.min(availableForCurrentOp, allocated); //Number(lot?.quantity);

    if (destemmingLiters <= totalKgAvailable) {
      toast.dismiss(customIdInvalidQuantities);
      // setIsOpen(true);
    } else {
      toast(
        getLabel("toast_destemmingInvalidQuantities", {
          sum: destemmingLiters || "0",
          total: totalKgAvailable,
        }),
        {
          toastId: customIdInvalidQuantities,
          type: toast.TYPE.ERROR,
          isLoading: false,
          position: toast.POSITION.BOTTOM_RIGHT,
        }
      );

      dest_tanks?.forEach((_, index) =>
        setError(`dest_tanks.${index}.quantity`, {
          type: "manual",
          message: getLabel("toast_invalidQuantity"),
        })
      );
      return;
    }

    dest_tanks?.forEach((tank) => {
      if (
        tank?.tankData?.color &&
        tank?.tankData?.color !== getValues("batch_id_in")?.color
      ) {
        toast.warn(getLabel("toast_WarningDiffentWineColor"), {
          toastId: customIdInvalidColor,
          position: toast.POSITION.BOTTOM_RIGHT,
          exclude: true,
          autoClose: 5000,
        });
        return false;
      }
    });

    setIsOpen(true);
  };

  const getLotData = (lot) => {
    const allocatedInitialQuantity = id ? getTotalQuantity(id > 0) : 0;
    // Calculate the quantity available for consumption in the current operation:
    // This is the difference between the real (current) quantity and what remains planned after scheduled operations.

    // Get the total allocated quantity across destination tanks (dynamic value)
    const allocated = getTotalQuantity();
    const availableForCurrentOp =
      allocatedInitialQuantity + (Number(lot?.planned_quantity) || 0);

    // The current operation can only remove as much as is available
    const checkedQuantity = allocated > availableForCurrentOp ? 0 : allocated; // avoid value over the available quantity
    const arrowQuantity = id
      ? checkedQuantity
      : Math.min(availableForCurrentOp, allocated);
    // Build the lotData object
    const lotData = {};
    lotData.name = lot?.name || lot?.label || "";
    lotData.color = lot?.color;
    lotData.initial_quantity = lot?.initial_quantity; // Fixed initial capacity (e.g., 100 Kg)

    // Set arrow_quantity: the amount to be removed by the current operation
    lotData.arrow_quantity = arrowQuantity;

    const isPlannedByOtherOps =
      lot?.is_planned && lot?.shared_operation_ids?.length > 0
        ? id
          ? lot.shared_operation_ids.some((opId) => Number(opId) !== Number(id))
          : true
        : false;

    lotData.is_planned = isPlannedByOtherOps; //lot?.is_planned;
    // Set the planned quantity for the current operation:
    // This represents how much will be consumed (arrowQuantity) and thus how much is 'planned' for removal.
    // (If no operation is executed, lot.quantity remains unchanged.)
    // In an editing context (when 'id' exists), we update values based on current distribution.
    if (id) {
      if (availableForCurrentOp > 0) {
        // For display when editing:
        // - The new "quantity" (i.e. what is scheduled to remain) is the planned_quantity from the lot.
        // - The amount consumed by the current operation is arrowQuantity.
        lotData.quantity = Number(lot?.planned_quantity) || 0; // What is expected to remain after scheduled ops
        lotData.planned_quantity = arrowQuantity; // Amount to be removed by the current op

        // For additional display details:
        // "real_initial_quantity" shows the total available for consumption (availableForCurrentOp)
        // "estimated_initial_quantity" shows what remains if we subtract the arrowQuantity from the current quantity.
        lotData.real_initial_quantity = !isPlannedByOtherOps
          ? Number(lot?.quantity)
          : availableForCurrentOp;
        lotData.estimated_initial_quantity = !isPlannedByOtherOps
          ? 0
          : Number(lot?.quantity) - availableForCurrentOp;

        // Final quantity calculations after the current operation:
        // The real final quantity would be the current lot.quantity minus the amount removed
        lotData.real_final_quantity =
          (!isPlannedByOtherOps
            ? Number(lot?.quantity)
            : availableForCurrentOp) - arrowQuantity;
        lotData.estimated_final_quantity = !isPlannedByOtherOps
          ? 0
          : Number(lot?.quantity) - availableForCurrentOp;
      } else {
        // If nothing is available, all values become zero.
        lotData.quantity = 0;
        lotData.planned_quantity = 0;
        lotData.real_initial_quantity = 0;
        lotData.estimated_initial_quantity = 0;
        lotData.real_final_quantity = 0;
        lotData.estimated_final_quantity = 0;
      }
    } else {
      // For non-editing contexts, simply use the lot values.
      lotData.quantity = Number(lot?.quantity) || 0;
      lotData.planned_quantity = Number(lot?.planned_quantity) || 0;
      lotData.real_initial_quantity = Number(lot?.quantity) || 0;
      lotData.estimated_initial_quantity =
        (Number(lot?.quantity) || 0) - arrowQuantity;
      lotData.real_final_quantity = isPlannedByOtherOps //lot?.is_planned
        ? (Number(lot?.planned_quantity) || 0) - arrowQuantity
        : !id
        ? Number(lot?.quantity) - arrowQuantity
        : Number(lot?.quantity);
      // lotData.batch_name = lot?.name || lot?.label || "";
      lotData.estimated_final_quantity = Number(lot?.planned_quantity) || 0;
    }

    lotData.composition = lot?.composition;

    return lotData;
  };

  const getTankData = (t) => {
    const tank = t?.tankData;
    const quantity =
      tank?.availability >= Number(t?.quantity) && Number(t?.quantity) >= 0
        ? Number(t?.quantity)
        : 0;
    const new_batch_name =
      t?.batch_name_selector?.value === true && t?.new_batch_name
        ? t.new_batch_name
        : t?.batch_name_selector?.value === false
        ? t?.batch_name_selector?.label
        : "";

    const tankData = {};

    tankData.arrow_quantity = !id ? quantity : Number(t?.quantity);
    tankData.capacity = tank?.capacity;
    tankData.type = tank?.type;
    tankData.barrels_num = tank?.barrels_num;
    tankData.is_src = false;
    tankData.old_quantity = tank?.quantity;
    tankData.old_batch_name = tank?.lot || "";
    tankData.quantity = tank?.quantity + quantity;
    tankData.color = tank?.is_planned
      ? tank?.planned_batch_color
      : tank?.quantity > 0
      ? tank?.color
      : getValues("batch_id_in")?.color;

    tankData.is_planned = tank?.is_planned;
    tankData.is_planned_state = tank?.is_planned_state;
    tankData.planned_quantity = tank?.is_planned
      ? Number(tank?.planned_quantity) - (!id ? Number(tank?.quantity) : 0)
      : 0;
    tankData.planned_batch_name = tank?.planned_batch_name;
    tankData.planned_batch_type = tank?.planned_batch_type;

    if (
      tank?.planned_batch_name &&
      tank?.is_planned_by_other_ops &&
      !t?.batch_name_selector?.value
    ) {
      tankData.batch_name = tank?.planned_batch_name || new_batch_name;
      if (id) {
        tankData.batch_name = new_batch_name;
        tankData.planned_quantity =
          tankData.planned_quantity - tankData?.old_quantity;
      }
    } else {
      tankData.batch_name = new_batch_name;
      tankData.old_batch_name = tank?.lot;
    }

    return tankData;
  };

  const setDestTanks = () => {
    const dests = [];
    operation?.dest_tanks?.map((s) => {
      const tank = tanks?.find((t) => t.id === s.tank_id);

      const plannedLot = lots?.find(
        // planned only by the current op, so the lot name can be updated
        (l) => l?.id === s?.batch_id && l?.status === "PLANNED"
      );
      // const isPlannedByOtherOps =
      //   tank?.is_planned && plannedLot?.shared_operation_ids?.length > 0
      //     ? id
      //       ? plannedLot.shared_operation_ids.some((opId) => Number(opId) !== Number(id))
      //       : true
      //     : false;
      const isPlannedByOtherOps =
        tank?.is_planned &&
        ((id === null && tank?.programmed_as_dest?.length > 0) ||
          (id !== null &&
            tank?.programmed_as_dest?.some((p_id) => p_id !== Number(id))));

      // if (s?.tank_id == 88) console.log('isPlannedByOtherOps', s, plannedLot)
      // if same batch_name as src, simulate OLD because it inherits the src name
      const is_new =
        operation?.src_tanks?.[0]?.name === s?.batch_name ? false : s?.is_new;
      const d = {
        quantity: Number(s?.arrow_quantity),
        tankData: {
          value: tank?.id,
          name: tank?.name,
          type: tank?.type,
          barrels_num: tank?.barrels_num,
          label: tank?.name,
          is_src: false,
          capacity: Number(tank?.capacity),
          is_planned_by_other_ops: isPlannedByOtherOps,
          planned_quantity: isPlannedByOtherOps
            ? Number(tank?.planned_quantity) - Number(s?.arrow_quantity)
            : 0,
          is_planned: isPlannedByOtherOps,
          is_planned_state: tank?.is_planned_state,
          planned_batch_name: isPlannedByOtherOps
            ? tank?.planned_batch_name
            : "",
          planned_batch_type: tank?.planned_batch_type,
          quantity: Number(tank?.quantity),
          availability:
            Number(tank?.capacity) -
            Number(tank?.planned_quantity) +
            Number(s?.arrow_quantity),
          color: tank?.color,
          lot:
            lots?.find((lot) => lot?.id === tank?.batch_id)?.name ||
            getLabel("tankState_EMPTY"),
          programmed_as_src: tank?.programmed_as_src,
          programmed_as_dest: tank?.programmed_as_dest,
          is_planned_by_other_ops:
            tank?.is_planned &&
            tank?.programmed_as_dest?.filter(
              (p_id) => id === null || p_id !== Number(id)
            )?.length > 0,
        },
        new_batch_name: s?.batch_name || "",
        batch_name_selector: is_new
          ? {
              value: true,
              label: getLabel("lotNewName"),
            }
          : {
              value: false,
              label: s?.batch_name,
            },
      };
      dests.push(d);
    });

    replace(dests);
  };

  const resetDestTanks = (value) => {
    const initialBatchId = operation?.src_tanks?.[0]?.batch_id || null;
    const newBatchId = value?.value || null;

    // reset dest_tanks when changing src batch (otherwise max and min in dest_tanks do not works)
    if (
      dest_tanks?.length > 0 &&
      dest_tanks?.[0]?.tankData?.value &&
      (!id ||
        (id && newBatchId && initialBatchId && newBatchId !== initialBatchId))
    ) {
      replace(
        dest_tanks?.map((d) => {
          return {
            ...d,
            quantity: 0,
            new_batch_name: "",
            batch_name_selector: false,
          };
        })
      );
    } else if (
      dest_tanks?.length > 0 &&
      dest_tanks?.[0]?.tankData?.value &&
      id
    ) {
      setDestTanks();
    }
  };

  if (
    (
      lots?.filter(
        (lot) => lot?.state === "GRAPE" //&& lot?.id !== getValues("batch_id_in")?.value
      ) || []
    )?.length === 0
  ) {
    return (
      <div className="protocols_alert">
        <h6 className="protocols_alert_title">
          {getLabel("noGrapeLotsAlert")}
        </h6>
      </div>
    );
  }
  return (
    <div className="operation_form_wrapper">
      <form
        onSubmit={handleSubmit(openFormModal)}
        autoComplete="off"
        noValidate
      >
        <SourceSelector
          id={id}
          type={type}
          operation={operation}
          control={control}
          errors={errors}
          tanks={tanks}
          lots={lots}
          tank_id_in={batch_id_in}
          dest_tanks={dest_tanks}
          getTankData={getTankData}
          isMobile={isMobile}
          lotNames={lotNames}
        />
        {/* <h5>{getLabel("fromLot")}</h5>
        <div className="operation_form_wrapper_row">
          <Select
            onTableChange={(value) => resetDestTanks(value)}
            control={control}
            defaultValue={operation?.batch_id_in}
            name="batch_id_in"
            label={getLabel("operationDestemmingLot")}
            placeholder={getLabel("operationDestemmingLotPlaceholder")}
            error={errors}
            required={getLabel("inputRequiredError")}
            options={lots
              ?.filter(
                (lot) =>
                  lot?.state === "GRAPE" &&
                  lot?.id !== getValues("batch_id_in")?.value
              )?.sort((a, b) => {
                // last: disabled
                if (a.is_disabled && !b.is_disabled) return 1;
                if (!a.is_disabled && b.is_disabled) return -1;

                // top: fa-calendar icon
                if (a.icon === "fa-calendar" && b.icon !== "fa-calendar") return -1;
                if (a.icon !== "fa-calendar" && b.icon === "fa-calendar") return 1;

                // case insensitive
                return (a.name || "")?.localeCompare(b.name || "", undefined, {
                  numeric: true,
                  sensitivity: "base", // ignore upper/lowercase and accents
                });
              })
              ?.map?.((lot) => {
                return {
                  value: lot.id,
                  label: lot.name,
                  color: lot.color,
                  composition: lot?.composition,
                  initial_quantity: lot?.quantity,
                  quantity: lot?.actual_quantity,
                  planned_quantity: lot?.planned_quantity,
                  shared_operation_ids: lot?.shared_operation_ids,
                  is_planned: lot?.is_planned,
                  is_disabled:
                    !id &&
                    lot?.is_planned &&
                    Number(lot?.planned_quantity) <= 0, // i.e. if the in batch is all planned in other dests
                  icon:
                    (lot?.is_planned && Number(lot?.planned_quantity) >= 0) ||
                    lot?.is_planned_src > 0
                      ? "fa-calendar"
                      : null,
                };
              })}
            tooltip={getLabel("destemmingBatchInTooltip")}
          />
          {getValues("batch_id_in") && (
            <>
              <DestLotDetail
                lot={getLotData(getValues("batch_id_in"))}
                isRecap={false}
                isMobile={isMobile}
                isName={false}
                isAdditional={true}
              />
            </>
          )}
        </div> */}
        <DestinationSelector
          type={type}
          operation={operation}
          register={register}
          control={control}
          errors={errors}
          clearErrors={clearErrors}
          setError={setError}
          trigger={trigger}
          setValue={setValue}
          tanks={tanks}
          lots={lots}
          tank_id_in={batch_id_in}
          fields={fields}
          lotNames={lotNames}
          // dest_tanks={dest_tanks}
          append={append}
          update={update}
          remove={remove}
          getTankData={getTankData}
          isMobile={isMobile}
          watchedArray={dest_tanks}
        />
        {/* <div className="operation_form_wrapper_row vertical">
          <h6>{getLabel("toTanks")}</h6>
          {fields?.map?.((field, idx) => {
            return (
              <div key={field.id} className="operation_form_wrapper_row">
                <Select
                  label={getLabel("operationDestTankName")}
                  placeholder={getLabel("operationDestTanksPlaceholder")}
                  error={errors}
                  required={getLabel("inputRequiredError")}
                  name={`dest_tanks.${idx}.tankData`}
                  control={control}
                  options={tanks
                    ?.filter(
                      (tank) =>
                        (tank.quantity === 0 ||
                          tank.quantity === null ||
                          tank.state === "MUST") &&
                        ["BARRIQUE", "TONNEAU", "TANK", "AUTOCLAVE", "CASK", "VAT_CASK"].includes(tank?.type) &&
                        !dest_tanks?.some?.(
                          (field) => field?.tankData?.value == tank?.id
                        )
                    )
                    // ?.sort((a, b) =>
                    //   (a?.name)?.localeCompare(b?.name, undefined, {
                    //     numeric: true,
                    //   })
                    // )
                    ?.sort((a, b) => {
                      // last: disabled
                      if (a.is_disabled && !b.is_disabled) return 1;
                      if (!a.is_disabled && b.is_disabled) return -1;

                      // top: fa-calendar icon
                      if (a.icon === "fa-calendar" && b.icon !== "fa-calendar") return -1;
                      if (a.icon !== "fa-calendar" && b.icon === "fa-calendar") return 1;

                      // case insensitive
                      return (a.name || "")?.localeCompare(b.name || "", undefined, {
                        numeric: true,
                        sensitivity: "base", // ignore upper/lowercase and accents
                      });
                    })
                    ?.map?.((tank) => {
                      return {
                        value: tank?.id,
                        label: tank?.name,
                        type: tank?.type,
                        barrels_num: tank?.barrels_num,
                        is_disabled:
                          tank?.is_planned_src === true ||
                          Number(tank?.planned_quantity) ===
                            Number(tank?.capacity),
                        icon:
                          (tank?.is_planned &&
                            Number(tank?.planned_quantity) >= 0) ||
                          tank?.is_planned_src > 0
                            ? "fa-calendar"
                            : null,
                        // name:
                        //   tank?.name +
                        //   ` (${
                        //     lots?.find((lot) => lot?.id === tank?.batch_id)
                        //       ?.name || getLabel("tankState_EMPTY")
                        //   })`,
                        name:
                          tank?.name +
                          ` (${
                            tank?.is_planned &&
                            Number(tank?.planned_quantity) > 0
                              ? tank?.planned_batch_name || ""
                              : Number(tank?.quantity) <= 0
                              ? getLabel("tankState_EMPTY")
                              : lots?.find((lot) => lot?.id === tank?.batch_id)
                                  ?.name || getLabel("tankState_EMPTY")
                          })`,
                        tag: { value: `${Math.round((tank?.capacity || 0) / 10)} hL`, type: 'volume' },
                        capacity: Number(tank?.capacity),
                        quantity: Number(tank?.quantity),
                        // is_planned_by_other_ops: tank?.is_planned && lots
                        //   ?.find(
                        //     (l) =>
                        //       l?.id === tank?.planned_batch_id &&
                        //       l?.status === "PLANNED"
                        //   )?.shared_operation_ids?.length > 0
                        //     ? id
                        //       ? lots
                        //       ?.find(
                        //         (l) =>
                        //           l?.id === tank?.planned_batch_id &&
                        //           l?.status === "PLANNED"
                        //       ).shared_operation_ids.some((opId) => Number(opId) !== Number(id))
                        //       : true
                        //     : false,
                        is_planned_by_other_ops: tank?.is_planned && tank?.programmed_as_dest?.filter(p_id => id === null || p_id !== Number(id))?.length > 0,
                        is_planned: tank?.is_planned,
                        is_planned_state: tank?.is_planned_state,
                        planned_quantity: tank.planned_quantity,
                        planned_batch_name: tank.planned_batch_name,
                        planned_batch_type: tank.planned_batch_type,
                        planned_batch_color: tank?.planned_batch_color,
                        availability:
                          Number(tank?.capacity) -
                          Number(tank?.planned_quantity),
                        color: tank?.color,
                        lot:
                          lots?.find((lot) => lot?.id === tank?.batch_id)
                            ?.name || getLabel("tankState_EMPTY"),
                        programmed_as_src: tank?.programmed_as_src,
                        programmed_as_dest: tank?.programmed_as_dest,
                      };
                    })}
                  // tooltip={(idx === 0) ? getLabel("destemmingTankDestTooltip") : ''}
                />
                {getValues(`dest_tanks.${idx}.tankData`)?.value && (
                  <DestTankDetail
                    tank={getTankData(dest_tanks?.[idx])}
                    isDrop={false}
                    isName={false}
                    isFirst={idx === 0}
                    isMobile={isMobile}
                  ></DestTankDetail>
                )}
                {fields?.length > 0 &&
                  getValues(`dest_tanks.${idx}.tankData`)?.value && (
                    <Input
                      name={`dest_tanks.${idx}.quantity`}
                      register={register}
                      type="number"
                      label={getLabel(`operationSrcTankQuantity`)}
                      placeholder={getLabel(
                        "operationDestTanksQuantityPlaceholder"
                      )}
                      error={getError(idx, errors?.dest_tanks, "quantity")}
                      required={getLabel("inputRequiredError")}
                      min={{
                        value: 1,
                        message: getLabel("errorMinValue", { value: 1 }),
                      }}
                      // max={{
                      //   value: Math.min(
                      //     dest_tanks[idx]?.tankData?.availability,
                      //     getTotalQuantity(id > 0) +
                      //       Number(
                      //         getValues("batch_id_in")?.planned_quantity
                      //       ) || 0
                      //   ),
                      //   message: getLabel("errorMaxValue", {
                      //     value: Math.min(
                      //       dest_tanks[idx]?.tankData?.availability,
                      //       getTotalQuantity(id > 0) +
                      //         Number(
                      //           getValues("batch_id_in")?.planned_quantity
                      //         ) || 0
                      //     ),
                      //   }),
                      // }}
                      regExpPattern={{
                        value: INT_REGEX,
                        message: getLabel("errorInt"),
                      }}
                      tooltip={
                        idx === 0
                          ? getLabel("destemmingTankDestQuantityTooltip")
                          : ""
                      }
                      validate={(value) => {
                        const src_batch = getValues("batch_id_in") || {};
                        const allocatedInitialQuantity = id ? getTotalQuantity(id > 0) : 0;

                        const availableForCurrentOp =
                          allocatedInitialQuantity + (Number(src_batch?.planned_quantity) || 0);
                        
                        const otherQuantitiesSum = availableForCurrentOp - dest_tanks?.filter((_, i) => i !== idx)?.reduce(
                          (acc, curr) => {
                            return acc + (Number(curr?.quantity) || 0);
                          },
                          0
                        ) || 0;
                        const availability = Math.min(availableForCurrentOp, dest_tanks?.[idx]?.tankData?.availability, otherQuantitiesSum);
                        if (
                          value <= availability
                        )
                          dest_tanks?.forEach((_, index) =>
                            clearErrors(`dest_tanks.${index}.quantity`)
                          );
                        else return getLabel("errorMaxValue", { value: availability } );
                      }}
                    />
                  )}
                
                {(dest_tanks?.[idx]?.tankData?.value && !dest_tanks?.[idx]?.tankData?.is_planned_by_other_ops)
                     && (
                    <div className="new_batch_name">
                      <Select
                        control={control}
                        defaultValue={{
                          value: "",
                          label: "",
                        }}
                        name={`dest_tanks.${idx}.batch_name_selector`}
                        // name={`batch_name_selector.${idx}`}
                        // name="batch_name_selector"
                        label={getLabel("operationNewLotName")}
                        placeholder={getLabel("operationNewLotNamePlaceholder")}
                        error={errors}
                        required={getLabel("inputRequiredError")}
                        options={[
                          {
                            value: true,
                            label: getLabel("lotNewName"),
                            className: "bold",
                          },
                          ...computeLotNames(idx),
                        ]}
                        tooltip={
                          idx === 0
                            ? getLabel(
                                "destemmingTankDestBatchNameSelectorTooltip"
                              )
                            : ""
                        }
                      />
                      {dest_tanks?.[idx]?.batch_name_selector?.value && (
                        <Input
                          name={`dest_tanks.${idx}.new_batch_name`}
                          error={getError(
                            idx,
                            errors?.dest_tanks,
                            "new_batch_name"
                          )}
                          // name="new_batch_name"
                          register={register}
                          type="text"
                          label={getLabel("operationNewBatchName")}
                          placeholder={getLabel(
                            "operationNewBatchNamePlaceholder"
                          )}
                          // error={errors["new_batch_name"]}
                          required={getLabel("inputRequiredError")}
                          isReverse={true}
                          minLength={{
                            value: 3,
                            message: getLabel("errorMinLength", { value: 3 }),
                          }}
                          maxLength={{
                            value: 24,
                            message: getLabel("errorMaxLength", {
                              value: 24,
                            }),
                          }}
                          regExpPattern={{
                            value: ALPHA_NUM_SPACE_DASH_UNDERSCORE_REGEX,
                            message: getLabel("errorAlphaNumSpace_-"),
                          }}
                          validate={(value) => {
                            if (
                              getValues(`dest_tanks.${idx}.batch_name_selector`)
                                ?.value &&
                              lots
                                ?.map(
                                  (l) =>
                                    l?.status !== "PLANNED" && l?.state !== "GRAPE" &&
                                    l?.name?.toLowerCase?.()
                                )
                                ?.includes(value?.toLowerCase?.()?.trim())
                            ) {
                              // toast.error(
                              //   getLabel("toast_lotNameAlreadyPresent"),
                              //   {
                              //     toastId: customIdInvalidLotName,
                              //     position: toast.POSITION.BOTTOM_RIGHT,
                              //     exclude: true,
                              //     autoClose: 5000,
                              //   }
                              // );
                              // return false;
                              return getLabel("errorNewBatchNameAlreadyTaken", {
                                name: value,
                              });
                            }
                            // else {
                            // toast.dismiss(customIdInvalidLotName);
                            // return true;
                            // }
                          }}
                        />
                      )}
                    </div>
                  )}
                {
                  (dest_tanks?.[idx]?.tankData?.value &&
                  dest_tanks?.[idx]?.tankData?.is_planned_by_other_ops) && (
                    <div className="new_batch_name">
                      <Label
                        tooltip={getLabel(
                          "operationNewPlannedBatchNameTooltip"
                        )}
                        label={getLabel("operationNewPlannedBatchName")}
                      >
                        {dest_tanks?.[idx]?.tankData?.planned_batch_name}
                      </Label>
                    </div>
                  )}
                {fields?.length > 1 && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      remove(idx);
                    }}
                  >
                    -
                  </button>
                )}
              </div>
            );
          })}
          <button
            id="tanksD"
            onClick={(e) => {
              e.preventDefault();
              append({
                tankData: {},
                quantity: 0,
                new_batch_name: "",
                batch_name_selector: "",
              });
            }}
          >
            +
          </button>
        </div> */}
        <h6>{getLabel("operationAdditional")}</h6>
        <div className="operation_form_wrapper_row">
          <MultipleSelect
            name={`cellarman_ids`}
            control={control}
            label={getLabel("operationUser")}
            placeholder={getLabel("operationUserPlaceholder")}
            error={errors["cellarman_ids"]}
            required={getLabel("inputRequiredError")}
            options={users?.map?.((user) => {
              return {
                value: user?.id,
                label: user?.username,
              };
            })}
            tooltip={getLabel("destemmingCellarmenTooltip")}
          />
          <Select
            name="priority"
            control={control}
            label={getLabel("operationPriority")}
            placeholder={getLabel("operationPriorityPlaceholder")}
            error={errors}
            required={getLabel("inputRequiredError")}
            options={[
              {
                label: getLabel("lotQuality_HIGH"),
                value: "2",
              },
              {
                label: getLabel("lotQuality_MEDIUM"),
                value: "1",
              },
              {
                label: getLabel("lotQuality_LOW"),
                value: "0",
              },
            ]}
            // defaultValue={{
            //     value: "",
            //     label: "",
            //   }}
          />
          <DatePicker
            name="expire_date"
            control={control}
            label={getLabel("operationExpireDateForm")}
            error={errors["expire_date"]}
            required={getLabel("inputRequiredError")}
            dateFormat={configs.shortDateFormat}
            placeholder={getLabel("expiringDatePlaceholder")}
          />
          {getValues("expire_date") && (
            <Input
              name={"expire_date_exact"}
              register={register}
              label={getLabel("isExactDate")}
              error={errors["expire_date_exact"]}
              // isLabel={false}
              type={"checkbox"}
              checked={isExactDate}
              onChange={() => setIsExactDate((prev) => !prev)}
              customClassName={"confirm no_margin_top"}
              tooltip={getLabel("destemmingExactDate")}
            />
          )}
        </div>
        <div className="client_form_wrapper_row">
          <TextArea
            name="note"
            register={register}
            label={getLabel("clientNotes")}
            placeholder={getLabel("clientNotesPlaceholder")}
            error={errors["note"]}
          />
        </div>
        <div className="operation_form_wrapper_row">
          <Submit label={getLabel("submitForm")}></Submit>
        </div>
      </form>
      <ConfirmationModal
        isOpen={isOpen}
        onConfirm={sendData}
        onClose={handleCloseModal}
        description={getLabel("modalNewDestemmingDescription", {
          name: operation?.id || "",
        })}
        isOperationRecap={true}
        totalStep={0}
        errors={errors}
        getValues={getValues}
      >
        <OperationRecap
          type={"DESTEMMING"}
          control={control}
          register={register}
          getValues={getValues}
          errors={errors}
          lots={lots}
          lotNames={lots?.map((l) => l?.name)}
          dest_tanks={dest_tanks?.map((d, index) => {
            return {
              ...d?.tankData,
              state: getValues("batch_id_in")?.state || Number(d?.tankData?.quantity) > 0 ? d?.tankData?.state : null,
              name: d?.tankData?.label,
              color: d?.tankData?.color || getValues("batch_id_in")?.color,
              add_quantity: Number(d?.quantity),
              old_quantity: Number(d?.quantity) + Number(d?.tankData?.quantity),
              planned_quantity:
                d?.tankData?.is_planned && d.tankData?.is_planned_by_other_ops
                  ? Number(d?.tankData?.planned_quantity) -
                    Number(d?.tankData?.quantity)
                  : 0,
              quantity: Number(d?.quantity) + Number(d?.tankData?.quantity),
              batch_name:
                d?.batch_name_selector?.value === true
                  ? d?.new_batch_name
                  : d?.batch_name_selector?.label ||
                    d?.tankData?.planned_batch_name,
              is_planned:
                d?.tankData?.is_planned && d.tankData?.is_planned_by_other_ops,
              // batch_name2: d?.tankData?.is_planned ? d?.tankData?.planned_batch_name :
              //   d?.batch_name_selector?.value === true
              //     ? d?.new_batch_name
              //     : d?.batch_name_selector?.label,
            };
          })}
          src_tanks={[getLotData(getValues("batch_id_in"))]}
        />
      </ConfirmationModal>
    </div>
  );
};

export default DestemmingForm;
